export default "__VITE_ASSET__Dbw2Vpm9__"